import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC } from 'react';
import { Box, DialogContent, TextField, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { generateGpsrDocRequest } from 'redux/reducers/gpsr/reducer';
import { useParams } from 'react-router';
import { Notice } from 'ui/Notice';
import { validationSchema } from './validationSchema';
import { TGenerateGpsrDeclarationDialogProps } from './types';

export const GenerateGpsrDeclarationDialog: FC<TGenerateGpsrDeclarationDialogProps> = ({
	open,
	setClose,
	communicationPhoneNumber,
	communicationEmail,
	testingInformation,
}) => {
	const params = useParams<{ productTypeId: string }>();
	const dispatch = useDispatch();
	// const [testingInform, setTestingInform] = useState<string>('');
	// const [phone, setPhone] = useState<string>('');
	// const [email, setEmail] = useState<string>('');

	// const reset = () => {
	// 	setTestingInform('');
	// 	setPhoneNumber('');
	// 	setEmail('');
	// };

	const formikGpsr = useFormik({
		initialValues: {
			communicationPhoneNumber,
			communicationEmail,
			testingInformation,
		},
		enableReinitialize: true,
		validationSchema,

		onSubmit: (values) => {
			// console.log('onSubmit', values);
			if (!params.productTypeId) return;

			dispatch(
				generateGpsrDocRequest({
					productTypeId: +params.productTypeId,
					body: {
						communicationEmail: values.communicationEmail,
						communicationPhoneNumber: values.communicationPhoneNumber,
						testingInformation: values.testingInformation,
					},
				}),
			);

			formikGpsr.resetForm();
			// reset();
			setClose();
		},
	});

	// useEffect(() => {
	// 	dispatch(getGpsrPlansRequest());
	// }, [dispatch]);

	// useEffect(() => {
	// 	if (!open) return;
	// 	if (!setNewComment) return;
	// 	setPhoneNumber(gpsrRegParser?.communicationPhone ?? '');
	// 	setEmail(gpsrRegParser?.communicationEmail ?? '');
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [gpsrRegParser]);

	return (
		<Dialog
			open={open}
			sx={{
				'& .MuiDialog-paper': {
					width: '600px',
					maxWidth: '600px',
					borderRadius: '12px',
				},
			}}
		>
			<DialogTitle color="primary">
				<Typography variant="h6" color="primary">
					Generate GPSR Declaration
				</Typography>
			</DialogTitle>
			<form onSubmit={formikGpsr.handleSubmit}>
				<DialogContent
					sx={{
						p: '0 12px 0px 12px',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
							gap: '16px',
						}}
					>
						<Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '4px' }}>
							<TextField
								id="communicationPhoneNumber"
								name="communicationPhoneNumber"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="Phone number"
								value={formikGpsr.values.communicationPhoneNumber}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={
									formikGpsr.touched.communicationPhoneNumber &&
									Boolean(formikGpsr.errors.communicationPhoneNumber)
								}
								helperText={
									formikGpsr.touched.communicationPhoneNumber &&
									formikGpsr.errors.communicationPhoneNumber
								}
							/>

							<TextField
								id="communicationEmail"
								name="communicationEmail"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="Email"
								value={formikGpsr.values.communicationEmail}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={
									formikGpsr.touched.communicationEmail &&
									Boolean(formikGpsr.errors.communicationEmail)
								}
								helperText={
									formikGpsr.touched.communicationEmail && formikGpsr.errors.communicationEmail
								}
							/>
							<Notice sx={{ mt: 1 }}>
								<>
									Please fill list of performed applicable for your products tests. If test
									performed based on some EU regulation add the regulation number. If no tests
									performed, please enter “<b>Not applicable</b>”. <br /> Example:{' '}
									<b>Coloring tests as per Directive 2009/35/EC</b>.
								</>
							</Notice>

							<TextField
								id="testingInformation"
								name="testingInformation"
								sx={{
									mt: '12px',
									'& .MuiInputBase-root': {
										padding: '10px 8px',
										lineHeight: '1.2',
										// fontSize: '0.9rem',
										// height: '100%',
									},
								}}
								autoFocus
								label="Testing Information"
								value={formikGpsr.values.testingInformation}
								// onChange={handleParseText}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								multiline
								rows={6}
								variant="outlined"
								error={
									formikGpsr.touched.testingInformation &&
									Boolean(formikGpsr.errors.testingInformation)
								}
								helperText={
									formikGpsr.touched.testingInformation && formikGpsr.errors.testingInformation
								}
							/>
						</Box>
					</Box>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							formikGpsr.resetForm();
							// reset();
							setClose();
						}}
					>
						Cancel
					</Button>
					<Button type="submit" autoFocus>
						Send
					</Button>
				</DialogActions>
			</form>
		</Dialog>
	);
};
